import { apiServer } from "../config";

export type MapSettings = {
  mapUpdate: boolean;
  mapUpdateTimeout: string;
  mapUpdateDistance: string;
  mapUpdateWithZoom: boolean;
  mapUpdateShowLoading: boolean;
};

export async function loadMapSettings() {
  const response = await fetch(`${apiServer + "/appsettings/map_settings"}`, {
    method: "GET",
  });
  const data = await response.json();
  if (data.status === "error") {
    throw new Error(data.message);
  } else {
    return data.mapDefaultSettings.progressiveSearch as MapSettings;
  }
}
